import d3 from 'd3';
import { Classes } from '../constants';
import mwcMarketsCore from 'mwc-markets-core';

const { utils } = mwcMarketsCore;
export default function drawSliderArea({
    selection,
    xScale,
    xValue,
    yValue,
    ySlider,
    dateRangeForSlider,
    yScale,
    yScaleHeight,
    data,
    valid,
    className = '',
    styles
} = {}) {
    // Only draw for main security
    if (!data || !data.length) {
        return;
    }

    // --- Setup area path ---
    const width = xScale.range()[1];
    const height = yScaleHeight.range()[0];
    const area = d3.svg
        .area()
        .x(function(d) {
            return xScale(xValue(d));
        })
        .y0(height)
        .y1(function(d) {
            return yScale(ySlider(d));
        })
        .defined(valid);

    const target = selection
        .append('g')
        .attr('class', `${Classes.GRAPH_AREA} ${className}`);
    const clipId = `${utils.guid()}#clip`;
    const areaPath = area(data);
    if (
        areaPath &&
        typeof areaPath === 'string' &&
        areaPath.trim().length > 0 &&
        areaPath !== 'MNaN,NaNLNaN,NaNZ'
    ) {
        target
            .append('path')
            .attr('clip-path', 'url(#' + clipId + ')')
            .attr('d', areaPath)
            .style(styles);
    }

    // --- Setup x scales for brush ---
    // Use the actual data's min/max date for the domain
    const dataDates = data.map(d => new Date(d.date));
    const minDate = d3.min(dataDates);
    const maxDate = d3.max(dataDates);

    var x = d3.time
        .scale()
        .range([0, width])
        .domain([minDate, maxDate]);
    var x2 = d3.time
        .scale()
        .range([0, width])
        .domain([minDate, maxDate]);

    // Clamp brush extent to data domain
    let brushStart = minDate,
        brushEnd = maxDate;
    if (dateRangeForSlider && dateRangeForSlider.length === 2) {
        const reqStart = new Date(dateRangeForSlider[0]);
        const reqEnd = new Date(dateRangeForSlider[1]);
        brushStart = reqStart < minDate ? minDate : reqStart;
        brushEnd = reqEnd > maxDate ? maxDate : reqEnd;
    }

    var brush = d3.svg
        .brush()
        .x(x2)
        .extent([brushStart, brushEnd])
        .on('brush', brushed);

    var context = selection
        .append('g')
        .attr('class', 'context')
        .attr('transform', 'translate(' + 10 + ',' + 10 + ')');
    context
        .append('g')
        .attr('class', 'range-slider-brush')
        .call(brush)
        .selectAll('rect')
        .attr('y', -9)
        .attr('height', height);

    // Ensure brush is drawn at correct position on init
    context.select('.range-slider-brush').call(brush);

    function brushed() {
        // Clamp brush extent to data domain
        let extent = brush.extent();
        if (extent[0] < minDate) {
            extent[0] = minDate;
        }
        if (extent[1] > maxDate) {
            extent[1] = maxDate;
        }
        brush.extent(extent);
        x.domain(brush.empty() ? x2.domain() : brush.extent());
        launchEvent(brush.extent());
    }
    const launchEvent = data => {
        const event = new CustomEvent('sliderEvent', {
            detail: {
                date: data
            }
        });
        document.dispatchEvent(event);
    };
    return target;
}
